import { Base } from './_base.model';

export class EventBudget extends Base {
  id: number;
  category_id: string;
  category: { id: string; label: string };
  est: number;
  proj: number;
  paid: number;
}
